import { useAISuggestionRequest } from 'hooks/queries/aiSuggestionRequests/useAISuggestionRequest'
import { SuggestionRequestStatus, SuggestionRequestWithRequester } from 'types'
import { UseQueryOptions } from 'react-query'

interface Props {
  id: number
}

interface Options extends Omit<UseQueryOptions<{ request: SuggestionRequestWithRequester }>, 'refetchInterval'> {
  intervalMs?: number
}

export const usePollAISuggestionRequest = ({ id }: Props, options?: Options) => {
  return useAISuggestionRequest(
    { id },
    {
      refetchInterval: (data) => {
        if (
          data?.request.status !== undefined &&
          [
            SuggestionRequestStatus.Successful,
            SuggestionRequestStatus.Failed,
            SuggestionRequestStatus.Aborted,
            SuggestionRequestStatus.Expired,
          ].includes(data.request.status)
        ) {
          return false
        }

        return options?.intervalMs || 500
      },
      ...options,
    },
  )
}
